<template>
  <div style="width: 100%; height: 100%;">
    <slot v-bind="slotData"></slot>
  </div>
</template>

<script>
 import { createNamespacedHelpers } from 'vuex'

 const { mapState, mapActions, mapGetters } = createNamespacedHelpers('browser')
 import { createValidator } from '@/utils/validation.js'
 import { createMapper } from '@/utils/mapping.js'

 const validator = createValidator('browser')
 const mapper = createMapper('browser')

 export default {
   props: {
     content: {
       type: Array,
       required: true
     }
   },
   watch: {
     '$route.query': {
       handler(query) {
	 const { textVisible } = validator.clean(mapper.fromURL(query))
	 this.setTextVisibility(textVisible)
       },
       immediate: true
     },
     isTextVisible: {
       handler(value) {
	 if (value === false) {
	   // make all text invisible
	   this.clearSelectedElements()
	 }
	 else {
	   // make all text visible
	   this.content.forEach((element) => this.addSelectedElement(element.id))
	 }

	 // FIXME: do not set url param if value equal to default value anyway

	 if (value !== validator.getDefault('textVisible')) {
	   this.$router.push({
	     ...this.$route,
	     query: {
	       ...this.$route.query,
	       ...mapper.toURL({ textVisible: true })
	     }
	   })
	 }
	 else {
	   const { textVisible, ...query } = mapper.fromURL(this.$route.query)
	   this.$router.push({
	     ...this.$route,
	     ...mapper.toURL(query)
	   })
	 }
       },
       immediate: true
     },
     selectedElements: {
       handler(elements) {
	 this.content.forEach((element) => {
	   const state = this.elementStates[element.id]
	   this.elementStates[element.id] = Object.assign({}, { state }, {
	     isTextVisible: elements.includes(element.id)
	   })
	 })
       },
       immediate: true
     }
   },
   data() {
     // FIXME: do highlighting, result snippet parsine here??
     return {
       elementStates: this.content.reduce((obj, val) => ({
	 ...obj,
	 [val.id]: {
	   isTextVisible: this.isTextVisible,
	   isHighlighted: val.highlight
	 }
       }), {}),
       isReady: false
     }
   },
   computed: {
     ...mapGetters(['isTextVisible']),
     ...mapState(['selectedElements']),
     slotData() {
       return {
	 handleElementClick: this.handleClick,
	 elements: this.statefulElements
       }
     },
     statefulElements() {
       return this.content.map((element) => ({
	 ...this.elementStates[element.id],
	 ...element
       }))
     },
   },
   beforeDestroy() {
     this.clearSelectedElements()
   },
   methods: {
     ...mapActions([
       'toggleElementTextVisibility',
       'addSelectedElement',
       'clearSelectedElements',
       'setTextVisibility'
     ]),
     handleClick(id) {
       this.toggleElementTextVisibility(id)
     },
   }
 }
</script>
